// extracted by mini-css-extract-plugin
export default {"text":"DeactivatedCrematoryModal_text__eKnkk"};